import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsVE: CultureInfo = {
  name: 'es-VE',
  displayName: 'Spanish (Venezuela)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-VE',
  parent: CultureInfoEs
};
